import { render, staticRenderFns } from "./FormAsetuksetPaamiesasetukset.vue?vue&type=template&id=4dbdc3b8&"
import script from "./FormAsetuksetPaamiesasetukset.vue?vue&type=script&lang=js&"
export * from "./FormAsetuksetPaamiesasetukset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbdc3b8')) {
      api.createRecord('4dbdc3b8', component.options)
    } else {
      api.reload('4dbdc3b8', component.options)
    }
    module.hot.accept("./FormAsetuksetPaamiesasetukset.vue?vue&type=template&id=4dbdc3b8&", function () {
      api.rerender('4dbdc3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAsetuksetPaamiesasetukset.vue"
export default component.exports